import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24f272f7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-container" }
const _hoisted_2 = {
  class: "application-wrapper",
  ref: "scrollContainer",
  "aria-label": "신규노선 신청"
}
const _hoisted_3 = {
  type: "button",
  tabindex: "0",
  "aria-label": "주소 검색",
  style: { padding: 0 }
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-space" }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("main", _hoisted_2, [
        _createVNode($setup["VocEditGuideMessage"], { htmlText: "(<span class='emphasis'> * </span>)는 필수 입력 사항입니다." }),
        ($setup.campusFilter)
          ? (_openBlock(), _createBlock($setup["LabeledCustomSelect"], {
              key: 0,
              class: "select-container",
              name: "campus",
              label: "캠퍼스",
              required: true,
              filter: $setup.campusFilter,
              placeholder: "선택",
              onOnSelectOption: $setup.updateSelectOption
            }, null, 8 /* PROPS */, ["filter"]))
          : _createCommentVNode("v-if", true),
        ($setup.workTimeFilter)
          ? (_openBlock(), _createBlock($setup["LabeledCustomSelect"], {
              key: 1,
              class: "select-container gap",
              name: "lineTime",
              label: "근무형태",
              required: true,
              filter: $setup.workTimeFilter,
              placeholder: "근무형태",
              onOnSelectOption: $setup.updateSelectOption
            }, null, 8 /* PROPS */, ["filter"]))
          : _createCommentVNode("v-if", true),
        ($setup.directionFilter)
          ? (_openBlock(), _createBlock($setup["LabeledCustomSelect"], {
              key: 2,
              class: "select-container gap",
              name: "direction",
              label: "방향",
              required: true,
              filter: $setup.directionFilter,
              placeholder: "선택",
              onOnSelectOption: $setup.updateSelectOption
            }, null, 8 /* PROPS */, ["filter"]))
          : _createCommentVNode("v-if", true),
        ($setup.weekdayFilter)
          ? (_openBlock(), _createBlock($setup["LabeledCustomSelect"], {
              key: 3,
              class: "select-container gap",
              name: "weekday",
              label: "통상구분",
              filter: $setup.weekdayFilter,
              required: true,
              placeholder: "선택",
              onOnSelectOption: $setup.updateSelectOption
            }, null, 8 /* PROPS */, ["filter"]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("button", _hoisted_3, [
          _createVNode($setup["TextInput"], {
            class: "input-container address gap",
            name: "address",
            label: "주소 검색",
            required: true,
            placeholder: "주소를 입력하세요",
            readonly: true,
            value: $setup.address,
            onClick: $setup.emitOnClickAddressInput
          }, null, 8 /* PROPS */, ["value"])
        ]),
        _createVNode($setup["BaseTextarea"], {
          class: "textarea-container",
          name: "bodyText",
          label: "내용",
          placeholder: "내용을 입력하세요",
          value: $props.applicationDetail?.bodyText,
          onOnInput: _cache[0] || (_cache[0] = ($event: any) => ($setup.updateData($event, 'bodyText')))
        }, null, 8 /* PROPS */, ["value"]),
        _hoisted_4
      ], 512 /* NEED_PATCH */),
      _createVNode($setup["FooterButton"], {
        title: $setup.footerBtnTitle,
        disabled: !$setup.isValid,
        onOnClickFooterButton: $setup.applyNewRoute
      }, null, 8 /* PROPS */, ["title", "disabled"])
    ]),
    ($setup.scrollContainer)
      ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
          key: 0,
          container: $setup.scrollContainer,
          style: { bottom: '80px' }
        }, null, 8 /* PROPS */, ["container"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}